// extracted by mini-css-extract-plugin
export default {"select":"styles_select__XwPIq","select__dropdown":"styles_select__dropdown__c5Wd1"};